import React from 'react';
import styled from '@emotion/styled';
import { DownloadSimple } from 'phosphor-react';
import screenSizes from '../../../constants/screenSizes';

const DownloadSection = styled.div`
  width: 100%;
  margin-top: 20px;
`;

const DownloadLine = styled.div`
  font-size: 14px;
  line-height: 20px;
  margin-top: 8px;
  font-weight: 600;
  padding-bottom: 12px;
  color: rgba(82, 94, 104, 1);
  display: flex;
  flex-direction: row;

  @media (min-width: ${screenSizes.medium.min}) {
    font-size: 16px;
    line-height: 23px;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
  }
`;

const ContentPart = styled.span`
  display: flex;
  flex-direction: row;
  gap: 10px;

  @media (min-width: ${screenSizes.medium.min}) {
    flex: 0 0 78%;
    text-align: left;
  }
`;

const DownloadItem = styled.div`
  display: flex;
  align-items: center;
  background-color: white;
  border-radius: 20px;
  padding: 1px 10px;
  width: fit-content;

  @media (min-width: ${screenSizes.medium.min}) {
    width: fit-content;
  }
`;

const DownloadLink = styled.a`
  color: rgba(144, 165, 185, 1) !important;
  text-decoration: none;
  font-weight: 700;
  display: flex;
  align-items: center;
  font-size: 10px;
  font-family: 'Inter', sans-serif;
  width: 100%;
  justify-content: center;

  @media (min-width: ${screenSizes.medium.min}) {
    width: auto;
    justify-content: flex-start;
  }
`;

const IconWrapper = styled.span`
  margin-right: 8px;
  display: flex;
  align-items: center;
`;

const DownloadLinksMapPreview = ({ title, pdfName, excel, wmap, gdp, shp, kml, wms, id }) => {
  return (
    <DownloadSection>
      <DownloadLine>
        <ContentPart>
          {pdfName && (
            <DownloadItem>
              <DownloadLink
                href={`/static/unosat_filesystem/${id}/${pdfName}`}
                download={pdfName}
                target="_blank"
              >
                <IconWrapper>
                  <DownloadSimple size={12} />
                </IconWrapper>
                PDF
              </DownloadLink>
            </DownloadItem>
          )}
          {shp && (
            <DownloadItem>
              <DownloadLink href={shp} download={shp}>
                <IconWrapper>
                  <DownloadSimple size={16} />
                </IconWrapper>
                SHP
              </DownloadLink>
            </DownloadItem>
          )}
          {gdp && (
            <DownloadItem>
              <DownloadLink href={gdp} download={gdp}>
                <IconWrapper>
                  <DownloadSimple size={16} />
                </IconWrapper>
                GDB
              </DownloadLink>
            </DownloadItem>
          )}
          {excel && (
            <DownloadItem>
              <DownloadLink href={`/static/${excel}`} download={title}>
                <IconWrapper>
                  <DownloadSimple size={16} />
                </IconWrapper>
                XLS
              </DownloadLink>
            </DownloadItem>
          )}
          {wmap && (
            <DownloadItem>
              <DownloadLink href={wmap} target="_blank">
                <IconWrapper>
                  <DownloadSimple size={16} />
                </IconWrapper>
                WEB
              </DownloadLink>
            </DownloadItem>
          )}
          {wms && (
            <DownloadItem>
              <DownloadLink href={wms}>
                <IconWrapper>
                  <DownloadSimple size={16} />
                </IconWrapper>
                WMS
              </DownloadLink>
            </DownloadItem>
          )}
          {kml && (
            <DownloadItem>
              <DownloadLink href={kml} download={kml}>
                <IconWrapper>
                  <DownloadSimple size={16} />
                </IconWrapper>
                KML
              </DownloadLink>
            </DownloadItem>
          )}
        </ContentPart>
      </DownloadLine>
    </DownloadSection>
  );
};

export default DownloadLinksMapPreview;
